import {ElMessage} from "element-plus";
const state = {
    //选中的项目信息
    selectProject: {},  // 选中的项目信息
    // 选中的设备信息
    selectedDevice: {},  // 选中的设备信息
    addTask: [],  // 添加的任务
    editTask: null,  // 编辑的任务
    editIndex: -1,  // 修改的任务索引
};

//操作管理
const mutations = {
    SET_SELECTED_PROJECT(state, data = null) {
        state.selectProject = data
    },
    SET_SELECTED_DEVICE(state, data = null) {
        state.selectedDevice = data
    },
    SET_ADD_TASK(state, data = null) {
        state.addTask.push(data)
    },
    SET_DEL_TASK(state, data = null) {
        state.addTask = state.addTask.filter(el => el?.taskName !== data?.taskName)
    },

    // 设置需要编辑的任务信息
    setEditTaskIndex(state, index = -1) {
        state.editIndex = index  // 设置需要编辑的任务索引
    },
    // 修改指定任务
    SET_TASK_UPDATE(state, data = null) {
        if(state.editIndex >= 0){
            state.addTask[state.editIndex] = data
        }

    },
    // 重置任务
    RESET_TASK(state) {
        state.addTask = []
    },
    SET_EDIT_TASK(state, data = null) {
        state.editTask = data
    }
}

// 异步操作
const actions = {
    // 设置选中的项目信息
    setSelectedProject({ commit }, data = null) {
        // 设置缓存
        commit("SET_SELECTED_PROJECT", data);
    },
    setSelectedDevice({ commit }, data = null) {
        // 设置缓存
        commit("SET_SELECTED_DEVICE", data);
    },
    setAddTask({ commit }, data = null) {
        if(data){
            // 设置不能添加同名称的任务
            if(state.addTask?.find(el => el?.taskName === data?.taskName)){
                ElMessage.warning(`${data?.taskName}任务已存在，请修改任务名称`)
            } else {
                // 设置缓存
                commit("SET_ADD_TASK", data);
            }
        }
    },
    // 删除指定任务
    setDelTask({ commit }, data = null) {
        commit("SET_DEL_TASK", data);
    },
    // 存储需要回显的任务
    setEditTaskIndex({ commit },  index = -1) {
        commit("setEditTaskIndex", index);
    },
    // 更新指定任务
    setUpdateTask({ commit }, data = null) {
        commit("SET_TASK_UPDATE", data);
    },
    // 重置任务
    resetTask({ commit }) {
        commit("RESET_TASK");
    },
    // 设置需要编辑的任务信息
    setEditTask({ commit }, data = null) {
        commit("SET_EDIT_TASK", data);
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
